import { Link } from "@inertiajs/react"
import { Archive, FileStack, Tags, type LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"

const TABS = [
  { key: "pipeline", href: "/pipeline",          label: "Pipeline",  align: "left",  icon: FileStack },
  { key: "tags",     href: "/tags",              label: "Tags",      align: "left",  icon: Tags      },
  { key: "archive",  href: "/pipeline/archive",  label: "Archive",   align: "right", icon: Archive   },
] as const satisfies readonly { key: string; href: string; label: string; align: string; icon: LucideIcon }[]

export type PipelineTabKey = (typeof TABS)[number]["key"]

// Shared sub-navigation rendered above /pipeline, /tags, and
// /pipeline/archive. The "Archive" tab is right-aligned because it's a
// destination for ended work, separated from the active workflow tabs.
export function PipelineSubNav({ active }: { active: PipelineTabKey }) {
  const left  = TABS.filter((t) => t.align === "left")
  const right = TABS.filter((t) => t.align === "right")

  const renderTab = (tab: (typeof TABS)[number]) => {
    const isActive = tab.key === active
    const Icon = tab.icon
    return (
      <Link
        key={tab.href}
        href={tab.href}
        className={cn(
          "-mb-px inline-flex items-center gap-1.5 border-b-2 px-1 py-3 text-sm no-underline",
          isActive
            ? "border-accent font-medium text-accent-display"
            : "border-transparent text-ink-body hover:text-ink-display",
        )}
      >
        <Icon className="h-3.5 w-3.5" />
        {tab.label}
      </Link>
    )
  }

  return (
    <nav className="flex flex-wrap items-end justify-between border-b border-hairline">
      <div className="flex flex-wrap items-end gap-6">{left.map(renderTab)}</div>
      <div className="flex flex-wrap items-end gap-6">{right.map(renderTab)}</div>
    </nav>
  )
}
